import { useEffect, useState } from "react";
import { Button, Grid } from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import FilterCard from "components/_refactor/filter-card";
import EconomicGroupStoreFields from "components/_refactor/fields/economic-group-store-fields";
import FromToDateField from "components/_refactor/fields/from-to-date";
import InputText from "components/_refactor/text/input";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import TableRequests from "../components/table-requests";
import { Add } from "@mui/icons-material";
import ViewDialog from "../components/dialog-view";
import DialogSendDocument from "../components/dialog-send-document";

const statusOptions = [
  { id: "ABERTA", Nome: "Aberta" },
  { id: "APROVADA", Nome: "Aprovada" },
  { id: "REPROVADO", Nome: "Reprovada" },
  { id: "AG_ENVIO_NOTA", Nome: "Aguardando Documentos" },
  { id: "DOC_EM_VALIDACAO", Nome: "Documentos em Validação" },
  { id: "DOC_APROVADOS", Nome: "Documentos Aprovados" },
  { id: "DOC_REPROVADOS", Nome: "Documentos Reprovados" },
];

export default function InitialRequestPage({ onNewRequest }) {
  const [fieldsValues, setFieldsValues] = useState({
    idGrupoEconomico: null,
    idPessoa: null,
    cnpj: null,
  });
  const [filters, setFilters] = useState({
    initialDate: null,
    finalDate: null,
    dateInvalid: false,
    product: "",
    invoice: "",
    status: null,
  });
  const [loadingFields, setLoadingFields] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [searching, setSearching] = useState(false);

  const [page, setPage] = useState(0);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(25);
  const [solicitationList, setSolicitationList] = useState([]);

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openSendDocumentDialog, setOpenSendDocumentDialog] = useState(false);
  const [idSolicitacao, setIdSolicitacao] = useState(null);

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);

    try {
      const response = await Api.get(
        "list-request-reason",
        "trocasDevolucoes",
        "?page=" +
          (page === 0 ? page : page - 1) +
          "&pageSize=" +
          sizePerPage +
          (fieldsValues.idGrupoEconomico
            ? "&idGrupoEconomico=" + fieldsValues.idGrupoEconomico
            : "") +
          (fieldsValues.idPessoa ? "&idPessoa=" + fieldsValues.idPessoa : "") +
          (fieldsValues.cnpj ? "&cnpj=" + fieldsValues.cnpj : "") +
          (filters.initialDate
            ? "&dtIni=" +
              (() => {
                const [dd, mm, yyyy] = filters.initialDate.split("-");
                return `${yyyy}-${mm}-${dd}`;
              })()
            : "") +
          (filters.finalDate
            ? "&dtFim=" +
              (() => {
                const [dd, mm, yyyy] = filters.finalDate.split("-");
                return `${yyyy}-${mm}-${dd}`;
              })()
            : "") +
          (filters.product ? "&idProduto=" + filters.product : "") +
          (filters.invoice ? "&numeroNota=" + filters.invoice : "") +
          (filters.status ? "&statusSolicitacao=" + filters.status : ""),
        true,
      );

      if (response.Result.TotalRegistros === 0) {
        snackbar.showMessage("Nenhuma solicitação de devolução encontrada", {
          severity: "info",
        });
        return;
      }

      setTotalRegistros(response.Result.TotalRegistros);
      setSolicitationList(response.Result.ListSolicitacao);
    } catch (e) {
      snackbar.showMessage("Erro ao buscar solicitações de devolução", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setFilters({
      initialDate: null,
      finalDate: null,
      dateInvalid: false,
      product: "",
      invoice: "",
      status: null,
    });
    setPage(0);
    setSolicitationList([]);
    setTimeout(() => {
      setClearFilters(false);
    }, 100);
  };

  const onView = (solicitation) => {
    setIdSolicitacao(solicitation.IdSolicitacao);
    setOpenViewDialog(true);
  };

  const onTableChange = (page, sizePerPage) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    handleSearch();
  };

  const onDownloadDocuments = (idSolicitacao) => {
    setIdSolicitacao(idSolicitacao);
    setOpenSendDocumentDialog(true);
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <>
      <FilterCard
        handleSearch={handleSearch}
        disabled={loadingFields.length > 0}
        searching={searching}
        handleClearFilters={handleClearFilters}
      >
        <EconomicGroupStoreFields
          onFieldsChange={setFieldsValues}
          onFieldsLoad={setLoadingFields}
          disableAll={searching}
          clearFilters={clearFilters}
        />
        <FromToDateField
          label="Período"
          initialDate={filters.initialDate}
          finalDate={filters.finalDate}
          setInitialDate={(value) =>
            setFilters((prev) => ({ ...prev, initialDate: value }))
          }
          setFinalDate={(value) =>
            setFilters((prev) => ({ ...prev, finalDate: value }))
          }
          disabled={loadingFields.length > 0 || searching}
        />
        <Grid item xs={12} md={3} lg={2}>
          <InputText
            label="Código Produto"
            value={filters.product}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                product: e.target.value.slice(0, 200),
              }));
            }}
            disabled={loadingFields.length > 0 || searching}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          <InputText
            label="Nota Fiscal"
            value={filters.invoice}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                invoice: e.target.value.slice(0, 10),
              }));
            }}
            disabled={loadingFields.length > 0 || searching}
          />
        </Grid>

        <Grid item xs={12} md={3} lg={2}>
          <AutoCompleteField
            label="Status"
            onChange={(value) => {
              setFilters((prev) => ({
                ...prev,
                status: value?.id,
              }));
            }}
            options={statusOptions}
            loading={loadingFields.length > 0 || searching}
            value={statusOptions.find((s) => s.id === filters.status) ?? null}
          />
        </Grid>
      </FilterCard>

      {solicitationList.length === 0 ? (
        <Grid container spacing={2} hidden={solicitationList.length > 0}>
          <Grid item xs={12} alignItems="flex-end">
            <Button variant="contained" color="primary" onClick={onNewRequest}>
              <Add />
              Solicitar Devolução
            </Button>
          </Grid>
        </Grid>
      ) : (
        <TableRequests
          data={solicitationList}
          onTableChange={(_, page, sizePerPage) =>
            onTableChange(page, sizePerPage)
          }
          onNewRequest={onNewRequest}
          onView={onView}
          totalRegistros={totalRegistros}
          currentPage={page}
          currentSizePerPage={sizePerPage}
          onDownloadDocuments={onDownloadDocuments}
        />
      )}

      {openViewDialog && (
        <ViewDialog
          onClose={() => {
            setOpenViewDialog(false);
            handleSearch();
          }}
          idSolicitacao={idSolicitacao}
        />
      )}

      {openSendDocumentDialog && (
        <DialogSendDocument
          onClose={() => setOpenSendDocumentDialog(false)}
          idSolicitacao={idSolicitacao}
          handleSearch={handleSearch}
        />
      )}
    </>
  );
}
